import { useSwrFetcherWithAccessToken } from "@/functions/useSwrFetcherWithAccessToken";
import useSWR from "swr";
import { CompanyIntroTypes } from "./interfaces/CompanyIntroductionInterface";
import { BackendApiUrl } from "@/functions/BackendApiUrl";
import { CompanyPrograms } from "@/components/Dashboard/CompanyProgramModel";

export function GetCompanyIntro(){
    const swrFetcher = useSwrFetcherWithAccessToken();
    const { data: intro } = useSWR<CompanyIntroTypes[]>(
        BackendApiUrl.getCompanyIntroduction,
        swrFetcher
    );
    return intro;
}

export function GetCompanyProgramList(){
    const swrFetcher = useSwrFetcherWithAccessToken();
    const { data } = useSWR<CompanyPrograms[]>(
        BackendApiUrl.getCompanyProgramsList,
        swrFetcher
    );
    return data;
}